import React from 'react';
import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/styles';

function MenuItemChip(props) {
  const theme = useTheme();
  return (
    <Chip
      sx={{
        backgroundColor: theme.palette.warning.main,
        color: 'white',
        height: '18px',
        fontSize: '10px',
        fontWeight: '400',
        borderRadius: '4px',
        marginLeft: '5px',
        '& > span': {
          paddingLeft: '4px',
          paddingRight: '4px'
        }
      }}
      label="NEW"
      {...props}
    />
  );
}

export default MenuItemChip;
